import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectAllRegistration } from "../../../../../../redux/slices/registrationSlice";
import { selectAllP2pSettings } from "../../../../../../redux/slices/p2pSettingsSlice";
import {
    selectTeams,
    updateTeams,
} from "../../../../../../redux/slices/teamsSlice";
import { selectCmsControlByType } from "../../../../../../redux/slices/cmsSettingsSlice";
import { selectCurrentForm } from "../../../../../../redux/slices/currentFormSlice";
import SearchBar from "./SearchBar";

const ConnectedSearchBar = () => {
    const {
        ENUMS: {
            CMS_Control: { P2P_REGISTRATION_CONTENT },
        },
    } = constants;

    const currentForm = useSelector(selectCurrentForm);

    const { currentRegistration, classification = {} } = useSelector(
        selectAllRegistration,
    );
    const { limitTeamJoiningToClassification = false } =
        useSelector(selectAllP2pSettings);
    const teams = useSelector(selectTeams);
    const newTeams =
        currentRegistration > 0
            ? teams.filter((team) => team.id === "new-team")
            : [];
    const control = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CONTENT, state),
    );
    const {
        options: {
            joinTeamModal: {
                searchPlaceholderLabel = "Find a Team or Team Captain...",
            },
        },
    } = control;

    const isVisible = teams && teams.length > 0;

    const hasClassification =
        Object.keys(classification).length > 0 &&
        classification.Classification &&
        classification.Classification[0];

    const classificationId =
        hasClassification && limitTeamJoiningToClassification
            ? Number(classification.Classification[0])
            : 0;

    const searchBarProps = {
        formId: currentForm,
        isVisible,
        newTeams,
        placeholder: searchPlaceholderLabel,
        classificationId,
        updateTeams,
    };
    return <SearchBar {...searchBarProps} />;
};

export default ConnectedSearchBar;
